/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { withTranslator } from '../../../I18n/withTranslator';

class ExternalProviderPlaceholder extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="placeholder-glow">
          <a href="" className="btn d-block btn-social facebook placeholder rounded">
            {this.props.t('auth/login/with-facebook')}
          </a>
        </div>
        <div className="placeholder-glow">
          <a href="" className="btn d-block btn-social google placeholder rounded">
            {this.props.t('auth/login/with-google')}
          </a>
        </div>
        <div className="placeholder-glow">
          <a href="" className="btn d-block btn-social apple placeholder rounded">
            {this.props.t('auth/login/with-apple')}
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslator(ExternalProviderPlaceholder);
